export class DocumentModel {
  id: number
  created_at: any
  type: string
  mime_type: string
  file_name: string
  description: string
  relevance: string
  status: string
  lyanthe_status: string
  status_reason: string
  status_remarks: string
  invoice_id: number
  invoice_type: string

  constructor(document) {
    {
      this.id = document.id

      if (document.created_at) {
        this.created_at = new Date(document.created_at)
      }
      this.type = document.type
      this.mime_type = document.mime_type
      this.file_name = document.file_name
      this.description = document.description
      this.relevance = document.relevance
      this.status = document.status
      this.lyanthe_status = document.lyanthe_status
      this.status_reason = document.status_reason
      this.status_remarks = document.status_remarks
      // this.invoice_id = document.invoice.id;
      // this.invoice_type = document.invoice_type;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/models/document-model.ts